// @ vendors
const Immutable = require('immutable');

// @ constants
const {
    INSURANCE_REQUEST_PRODUCT_DETAIL_INFORMATION,
    INSURANCE_REQUEST_PRODUCT_DETAIL_WRONG_REQUEST,
    INSURANCE_REQUEST_PRODUCT_DETAIL_IS_FETCHING,
    INSURANCE_REQUEST_FETCH_POLICY_IN_PROGRESS,
    INSURANCE_REQUEST_FETCH_POLICY_SUCCESS,
    INSURANCE_REQUEST_FETCH_POLICY_FAILURE,
} = require('../../insuranceConstants/actionTypes');

// @ reducers
const setInitialState = () => {
    return Immutable.Map().merge({
        response: {},
        error: false,
        pdfData: {},
        pdfError: false,
        pdfIsFetching: false,
        isFetching: false,
    });
};

const insuranceRequestProductDetail = (state = setInitialState(), action) => {
    const { type, data } = action;
    switch (type) {
        case INSURANCE_REQUEST_PRODUCT_DETAIL_INFORMATION:
            const { response } = data;
            return state.merge({
                response,
                error: false,
                isFetching: false,
            });
        case INSURANCE_REQUEST_PRODUCT_DETAIL_IS_FETCHING:
            return state.merge({
                isFetching: true,
            });
        case INSURANCE_REQUEST_PRODUCT_DETAIL_WRONG_REQUEST:
            return state.merge({
                isFetching: false,
                error: true
            });
        case INSURANCE_REQUEST_FETCH_POLICY_IN_PROGRESS:
            return state.merge({
                pdfIsFetching: true
            });
        case INSURANCE_REQUEST_FETCH_POLICY_SUCCESS:
            const { pdfData } = data;
            return state.merge({
                pdfData,
                pdfError: false,
                pdfIsFetching: false
            });
        case INSURANCE_REQUEST_FETCH_POLICY_FAILURE:
            return state.merge({
                pdfIsFetching: false,
                pdfError: true
            });
        default:
            return state;
    }
};

module.exports = insuranceRequestProductDetail;
module.exports.setInitialState = setInitialState;
